import { Consumer as C, createContext } from 'react';
import Config from '../../core/Config';

export const context = createContext<Config>({} as Config);

export const Provider = context.Provider;
export const Consumer = context.Consumer as C<Config>;
